import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  proficiency: null,
  status: 'idle',
  error: null,
  reportStatus: 'idle',
  reportError: null,
};

const slice = createSlice({
  name: 'progress',
  initialState,
  reducers: {
    proficiencyRequested(state) {
      if (state.status !== 'succeeded') state.status = 'loading';
      state.error = null;
    },
    proficiencyLoaded(state, action) {
      state.status = 'succeeded';
      state.proficiency = action.payload;
      state.error = null;
    },
    proficiencyFailed(state, action) {
      state.status = 'failed';
      state.error = action.payload ?? 'Failed to load score report';
    },
    detailedReportRequested(state) {
      state.reportStatus = 'loading';
      state.reportError = null;
    },
    detailedReportSucceeded(state) {
      state.reportStatus = 'succeeded';
    },
    detailedReportFailed(state, action) {
      state.reportStatus = 'failed';
      state.reportError = action.payload ?? 'Could not open detailed report';
    },
  },
});

export const {
  proficiencyRequested,
  proficiencyLoaded,
  proficiencyFailed,
  detailedReportRequested,
  detailedReportSucceeded,
  detailedReportFailed,
} = slice.actions;

export const progressReducer = slice.reducer;
